import EventBus from '../../../shared/js/wirebox/event-bus'
import jQuery from 'jquery'

class UsRepForm {
    
    /**
     * Construct component
     * @param form
    */
    constructor(form) {
        
        /**
         * Form jQuery object
         * @type {object}
        */
        this.form = form
        
        /**
         * Rep container jQuery object
         * @type {object}
        */
        this.detailsContainer = jQuery('#us-rep-details-container')
        
        /**
         * Rep content jQuery object
         * @type {object}
        */
        this.repContent = jQuery('#us-rep-details')
        
        this.bindEvents()
        
    }
    
    /**
     * Handle successful form submit
     * @param event
     * @param params
    */
    formSuccess(event, params) {
        
        let response = params.response
        
        //Render HTML
        this.repContent.html(response.details)
        
        //Show details container
        this.detailsContainer.slideDown()
        
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Form success
        this.form.on('form-ajax-success', this.formSuccess.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    let form = jQuery('#us-rep-lookup-form')
    
    if (form.length > 0) {
        new UsRepForm(form)
    }
    
})

export default UsRepForm